import React, { Fragment, useState, useEffect } from "react";
import "./banners.scss";
import TableList from "./TableList";
import Header from "../subheader/Header";
import { set_loading } from "../../../redux/actions/LayoutAction";
import { connect } from "react-redux";
import { apiJson } from "../../../api/Api";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { set_banners } from "../../../redux/actions/BannerAction";
import { Redirect, Link } from "react-router-dom";

const ShopBanners = (props) => {
  const [data, setData] = useState(false);
  const [createRedirect, setCreateRedirect] = useState(false);

  let message = "";
  const showError = () => {
    toast.error(message, {
      position: "bottom-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });
  };

  useEffect(() => {
    document.title = "Banners";
  }, []);

  useEffect(() => {
    apiJson.shop_banner.getBanners().then((response) => {
      if (response.success) {
        props.set_banners({ banners: response.data.banners });
        setData(true);
      } else if (!response.status) {
        // eslint-disable-next-line
        message = response.message
          ? response.message !== ""
            ? response.message
            : "something went wrong"
          : "something went wrong";
        showError();
        setData(true);
      } else {
        setData(true);
        if (response.status >= 400 && response.status < 500) {
          message = response.message
            ? response.message
            : response.errors
              ? response.errors
              : "something went wrong";
          showError();
        } else {
          message = response.message
            ? response.message !== ""
              ? response.message
              : "something went wrong"
            : "something went wrong";
          showError();
        }
      }
    });
  }, []);

  // eslint-disable-next-line
  useEffect(() => props.set_loading(!data), [data]);
  return (
    <>
      <Fragment>
        <div className="vendor-page-right coupons-page-desktop">
          <Header heading="Banners" search={false} filters={null} />
          {data && (
            <div className="right-content content-container-row">
              <Link
                className="btn btn-primary"
                to={{
                  pathname: "/vendor/shop-banner/create",
                  state: { name: "create" }
                }}
              >
                Create New Banner
              </Link>
              <br /><br />
              <div className="content mx-auto">
                {props.banners && <TableList List={props.banners} />}
              </div>
            </div>
          )}
        </div>
        {createRedirect && (
          <Redirect
            push
            to={{
              pathname: "/vendor/create-banner",
              state: { name: "create" },
            }}
          />
        )}
      </Fragment>
    </>
  );
};

const mapStateToProsps = (state) => {
  return { banners: state.banner.banners, load: state.layout.isLoading };
};

const mapDispatchToProps = { set_banners, set_loading };

export default connect(mapStateToProsps, mapDispatchToProps)(ShopBanners);
